import lodashGet from 'lodash/get';
import { wait } from '@/api/util/index';
export const handleAccountAndDomain = (account, context) => {
    return context.systemApi.handleAccountAndDomain(account);
};
export const computeEntityOrgMemberCount = async (options) => {
    const { rootOrgKey = '-2', orgTreeMap, orgContactMap } = options;
    const nodeMap = new Map([
        [
            '-2',
            {
                selfNodeKey: '-2',
                parentNodeKey: undefined,
                selfCount: 0,
                totalCount: 0,
            },
        ],
    ]);
    const findNextNode = (node) => {
        const { visitCount = 0, firstChildNodeKey, nextSiblingNodeKey, parentNodeKey } = node;
        if (visitCount <= 1) {
            if (firstChildNodeKey && nodeMap.get(firstChildNodeKey)) {
                return firstChildNodeKey;
            }
            node.visitCount = (node.visitCount || 0) + 1;
            return findNextNode(node);
        }
        if (nextSiblingNodeKey && nodeMap.get(nextSiblingNodeKey)) {
            return nextSiblingNodeKey;
        }
        if (parentNodeKey && nodeMap.get(parentNodeKey)) {
            return parentNodeKey;
        }
        return undefined;
    };
    const computeTotalCount = (flagNodeKey, map) => {
        const { firstChildNodeKey, selfCount = 0, selfNodeKey = undefined } = map.get(flagNodeKey);
        let totalCount = selfCount;
        let nextNode = firstChildNodeKey ? map.get(firstChildNodeKey) : undefined;
        while (nextNode && nextNode.selfNodeKey !== selfNodeKey) {
            const nextNodeCount = nextNode.totalCount;
            totalCount += nextNodeCount;
            const { nextSiblingNodeKey, parentNodeKey } = nextNode;
            if (nextSiblingNodeKey && map.get(nextSiblingNodeKey)) {
                nextNode = map.get(nextSiblingNodeKey);
            }
            else if (parentNodeKey && map.get(parentNodeKey)) {
                nextNode = map.get(parentNodeKey);
            }
            else {
                nextNode = undefined;
            }
        }
        return totalCount;
    };
    const traverse = async (currentNodeKey, map) => {
        let traverCountInFrame = 0;
        let isDone = false;
        while (currentNodeKey && map.get(currentNodeKey) && traverCountInFrame <= 1000 && !isDone) {
            const childlist = orgTreeMap.get(currentNodeKey);
            const currentNodeInfo = map.get(currentNodeKey);
            currentNodeInfo.visitCount = (currentNodeInfo.visitCount || 0) + 1;
            const { visitCount = 0 } = currentNodeInfo;
            if (visitCount >= 2) {
                const totalCount = computeTotalCount(currentNodeKey, map);
                currentNodeInfo.totalCount = totalCount;
            }
            else if (childlist && childlist.length) {
                currentNodeInfo.firstChildNodeKey = childlist[0];
                for (let index = 0; index < childlist.length; index++) {
                    const childId = childlist[index];
                    const isFirstChild = index <= 0;
                    const isLastChild = index >= childlist.length - 1;
                    const childNodeInfo = {
                        selfNodeKey: childId,
                        selfCount: orgContactMap.get(childId) || 0,
                        totalCount: 0,
                        visitCount: 0,
                        prevSiblingNodeKey: !isFirstChild ? lodashGet(childlist, `[${index - 1}]`, undefined) : undefined,
                        nextSiblingNodeKey: !isLastChild ? lodashGet(childlist, `[${index + 1}]`, undefined) : undefined,
                        parentNodeKey: currentNodeKey,
                    };
                    map.set(childId, childNodeInfo);
                }
            }
            else {
                currentNodeInfo.firstChildNodeKey = undefined;
                currentNodeInfo.totalCount = orgContactMap.get(currentNodeKey) || 0;
                currentNodeInfo.visitCount = 2;
            }
            const nextNodeKey = findNextNode(currentNodeInfo);
            traverCountInFrame += 1;
            map.set(currentNodeKey, currentNodeInfo);
            if (nextNodeKey) {
                currentNodeKey = nextNodeKey;
            }
            else {
                isDone = true;
            }
        }
        if (!isDone && traverCountInFrame >= 1000) {
            await wait(300);
            return traverse(currentNodeKey, map);
        }
    };
    await traverse(rootOrgKey, nodeMap);
    console.log('[contact_util]computeEntityOrgMemberCount.result:', nodeMap);
    return nodeMap;
};
